import styled from "styled-components"

export const About = () => {
    return (
        <DIV id='about'>
            <h1>About</h1>
            <p>
                A full stack web developer with expertise in both front-end and back-end development. With a solid understanding of HTML, CSS, JavaScript, and various frameworks, I am capable of creating responsive and visually appealing user interfaces. Additionally, I have experience in database management, server-side programming, and API integration, enabling me to build robust and efficient web applications. I am passionate about staying up-to-date with the latest technologies and implementing best practices to deliver high-quality and scalable solutions. Collaboration and problem-solving are my strengths, making me a valuable asset to any development team.
            </p>
        </DIV>
    )
}

const DIV = styled.div`
    @media (max-width: 480px) { 
    /* screen width is less than 480px (Phone) */
    width: 100%;
   margin: auto;
   padding: 10%;
   margin-top: 100px;
   
   h1{
        font-size: 30px;
        margin-bottom: 15px;
        font-weight: 500;
    }
    p{
        font-size:17px ;
        font-weight: 400;
        margin-bottom: 10px;
    }
    }
    @media (min-width: 481px) and (max-width: 768px) {
    /* screen width is between 481px (medium) and 768px (IPad) */
    width: 100%;
   margin: auto;
   padding: 10%;
   margin-top: 100px;
   
   h1{
        font-size: 35px;
        margin-bottom: 15px;
        font-weight: 500;
    }
    p{
        font-size:22px ;
        font-weight: 400;
        margin-bottom: 10px;
    }
    }
    @media (min-width: 769px) and (max-width: 1200px) {
    /* screen width is between 769px (medium) and 1024px (large) (Tablet)*/
    width: 100%;
   margin: auto;
   padding: 10%;
   margin-top: 100px;
   
   h1{
        font-size: 50px;
        margin-bottom: 15px;
        font-weight: 500;
    }
    p{
        font-size:25px ;
        font-weight: 400;
        margin-bottom: 10px;
    }
    }
    @media (min-width: 1201px){ 
    /* screen width is greater than 1200px (large) */
    width: 60%;
   margin: auto;
   padding: 10px;
   margin-top: 100px;
   
   h1{
        font-size: 40px;
        margin-bottom: 15px;
        font-weight: 500;
    }
    p{
        font-size:22px ;
        font-weight: 400;
        margin-bottom: 10px;
    }
    }
`